import axios from 'axios'

const getProfile = async (otherUser=false)=>{
    try{
        let userId;
        if(!otherUser){
            userId = JSON.parse(localStorage.getItem('userDetails'))._id;
        }
        else{
            userId = otherUser
        }
        const accessToken = localStorage.getItem('token');
        if (!accessToken) {
            throw new Error("Please Login!!!");
        }
        const headers = {
            authorization: `${accessToken}`,
        };
        let { data } = await axios.get(`${window.host}/profile/${userId}`, { headers });
        return data;
    }
    catch(err){
        if(process.env.NODE_ENV==='dev'){
            console.error(err.response.data.message);
        }
        return  []
    }
}

const updateProfile = async (payload = {}) => {
    try {
        const userId = JSON.parse(localStorage.getItem('userDetails') || '{}')._id;
        if (!userId) throw new Error("Please Login!!!");
        const accessToken = localStorage.getItem('token');
        if (!accessToken) {
            throw new Error("Please Login!!!");
        }

        let headers = {
            authorization: `${accessToken}`,
        };

        let body = payload;
        if (payload.profileImageFile instanceof File || payload.file instanceof File) {
            const formData = new FormData();
            const file = payload.profileImageFile || payload.file;
            formData.append('file', file);
            Object.entries(payload).forEach(([key, value]) => {
                if (key === 'profileImageFile' || key === 'file') return;
                if (value !== undefined && value !== null) {
                    formData.append(key, value);
                }
            });
            body = formData;
            headers = {
                ...headers,
                'Content-Type': 'multipart/form-data',
            };
        }

        const { data } = await axios.put(`${window.host}/profile/${userId}`, body, { headers });
        return data;
    } catch (err) {
        if (process.env.NODE_ENV === 'dev') {
            console.error(err?.response?.data?.message || err.message);
        }
        throw err;
    }
}

const uploadProfileImage = async (file) => {
    try {
        const accessToken = localStorage.getItem('token');
        if (!accessToken) {
            throw new Error("Please Login!!!");
        }
        const headers = {
            authorization: `${accessToken}`,
            'Content-Type': 'multipart/form-data',
        };
        const formData = new FormData();
        formData.append('file', file);
        const { data } = await axios.post(`${window.host}/upload`, formData, { headers });
        return data;
    } catch (err) {
        if (process.env.NODE_ENV === 'dev') {
            console.error(err?.response?.data?.message || err.message);
        }
        throw err;
    }
};

export default {getProfile, updateProfile, uploadProfileImage}
